<template>
  <component :is="type" :config="config"></component>
</template>

<script>
import RegularBar from './part/Regular'
import ServiceBase from './part/ServiceBase'
import BikeManagement from './part/BikeManagement'
import AddNewBike from './part/AddNewBike'
import BikeInfo from './part/BikeInfo'
import Accessories from './part/Accessories'
import UserManagement from './part/UserManagement'
import UserInfo from './part/UserInfo'

export default {
  components: {
    RegularBar,
    ServiceBase,
    BikeManagement,
    AddNewBike,
    BikeInfo,
    Accessories,
    UserManagement,
    UserInfo
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    type () {
      return this.config.component || 'regular-bar'
    }
  }
}
</script>
